import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {ChatChannel} from './chat-channel.types';

@Injectable({
    providedIn: 'root'
})
export class ChatCoordinatorService {
    private activeChannelSubject = new BehaviorSubject<ChatChannel | null>(null);
    private closeChannelSubject = new Subject<ChatChannel>();

    get closeChannel$(): Observable<ChatChannel> {
        return this.closeChannelSubject.asObservable();
    }

    /**
     * Marks a channel as open and asks the other channel to close.
     */
    notifyOpened(channel: ChatChannel): void {
        const previous = this.activeChannelSubject.value;
        if (previous && previous !== channel) {
            this.closeChannelSubject.next(previous);
        }
        this.activeChannelSubject.next(channel);
    }

    notifyClosed(channel: ChatChannel): void {
        if (this.activeChannelSubject.value === channel) {
            this.activeChannelSubject.next(null);
        }
    }
}
